export default __webpack_public_path__ + "static/media/adityabirla.9345857c.png";